<svg class="tw-h-3 tw-w-3">
  <use [attr.xlink:href]="'images/sprite.svg#' + icon()"></use>
</svg>
{{ label() }}
